import keyBy from 'lodash/keyBy';
import {
  useEncounterSettings,
} from 'pages/Dashboard/pages/Encounters/hooks';
import {
  useAppointmentStatusOptions,
} from 'views/EMR/stores/appointmentStatus';
import {
  useGetAlertTypes,
} from 'views/EMR/PatientAlerts/hooks';

const patientPreAppointmentStatuses = [{
  id: 1,
  caption: 'Would like to be seen sooner',
  value: true,
  isSchedule: true,
}, {
  id: 2,
  caption: 'Don\'t want to be seen sooner',
  value: false,
  isSchedule: true,
}, {
  id: 3,
  caption: 'Has completed Intake and Consent',
  value: true,
  isSchedule: false,
}, {
  id: 4,
  caption: 'Has incomplete Intake or pending Consent',
  value: false,
  isSchedule: false,
}];

export const preAppointmentStatusMapping = keyBy(patientPreAppointmentStatuses, 'id');

export default function useAppointmentsSettings() {
  const encounterSettings = useEncounterSettings();
  const appointmentStatuses = useAppointmentStatusOptions();
  const { data: patientAlertTypes } = useGetAlertTypes();

  return {
    ...encounterSettings,
    appointmentStatuses,
    patientPreAppointmentStatus: patientPreAppointmentStatuses,
    patientAlertTypes: patientAlertTypes ?? [],
  };
}
